// extracted by mini-css-extract-plugin
export default {"text":"VHDZaC","uppercase":"y_D2g7"};